import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'beta.300',
    endColor: 'beta.400',
    minW: 'full',
    h: '20',
    borderRadius: 'lg',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    sxWrapper: { mb: '0' },
    bg: 'blackAlpha.600',
    border: 'none',
    borderColor: 'blackAlpha.600',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.05)',
    borderRadius: 'md',
    mb: '0',
    _placeholder: {
      color: 'whiteAlpha.500',
      fontWeight: 'bold',
      fontSize: '2xs',
    },

    _hover: {
      '&&': {
        bg: 'blackAlpha.600',
        _placeholder: {
          color: 'whiteAlpha.500',
        },
      },
      borderColor: 'blackAlpha.600',
      color: 'white',
    },
    _active: {
      '&&': {
        bg: 'blackAlpha.600',
        _placeholder: {
          color: 'whiteAlpha.500',
        },
      },
      borderColor: 'blackAlpha.600',
      color: 'white',
    },
    _focus: {
      '&&': {
        bg: 'blackAlpha.600',
        _placeholder: {
          color: 'whiteAlpha.500',
        },
      },
      borderColor: 'blackAlpha.600',
      color: 'white',
      textShadow: 'sm',
    },
  },
  inputRightIcon: {
    boxSize: '4',
    color: 'yellow.300',
    as: Search,
    sx: {},
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '1',
    borderTop: '1px',
    borderTopColor: 'blackAlpha.400',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
    _first: {
      borderTop: 'none',
      pt: '0',
    },
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: { alignItems: 'center', gap: 2, flex: 1, textAlign: 'left' },
  accordionButtonIconSvg: {
    color: 'beta.600',
    fontSize: 'sm',
    sx: {},
  },
  accordionButtonText: {
    fontSize: ['sm', 'md'],
    fontWeight: 'medium',
    color: 'beta.600',
    textTransform: 'capitalize',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: '2xs',
    fontWeight: 'bold',
    color: 'beta.600',
  },
  accordionButtonInnerIcon: {
    pos: 'absolute',
    right: '0',
    boxSize: '6',
    color: 'gray.700',
    sx: {},
  },
  accordionPanel: {
    p: '0',
    mb: '3',
    mx: '1px',
  },
};
